import Api from './Api'

const endpoint = 'collaborators'

export default class CollaboratorService extends Api {

    async all () {
        const response = await this.client.get(`${endpoint}/all`)
        if (response.data) {
            return response.data.map(s => {
                return {
                    value: s.id,
                    text: s.name
                }
            })
        }
        throw new Error('No data')
    }
}